/** Logo Cavorama cliquable → https://cavorama.fr/ (nouvel onglet). `className` règle la hauteur. */
export const CavoramaLogo = ({ className = 'h-10', testid = 'cavorama-logo' }) => (
  <a
    href="https://cavorama.fr/"
    target="_blank"
    rel="noreferrer"
    className="inline-block hover:opacity-80 transition-opacity"
    data-testid={testid}
    aria-label="Cavorama.fr"
  >
    <img src="/cavorama-logo.png" alt="Cavorama.fr" className={`${className} w-auto`} />
  </a>
);

export default CavoramaLogo;
